import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'IconList',
})(({ brandColors, spacing, breakpoints }, props) => ({
  IconListRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: `${spacing(2)} 0`,
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
    [breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  itemBody: {
    marginTop: spacing(0),
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
  itemHeading: {
    marginTop: spacing(0),
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
}));

export default useStyles;
